<template>
  <div class="template">

    <div class="container">

      <div class="containerInner">

        <div class="columnLeft">
        </div>

        <div class="columnCenter">

            <router-link to="/" class="home">
              <h3>Digitalt perspektiv</h3>
            </router-link>

        </div>

        <div class="columnRight">
        </div>

      </div>

    </div>


  </div>
</template>

<script>

export default {
  components: {
  },
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.template{
  border-bottom: 1px solid lightgray;
  padding: 0px;
  background: rgb(230,230,230);
  top: 0;
  width: 100%;
  z-index: 10;
}

.home{
  color: black;
}

</style>



// WEBPACK FOOTER //
// src/components/HeaderView.vue